import { Button, ButtonProps } from "@mui/material";
import { FC } from "react";

interface SalifyTextButtonProps {
  text: string | undefined;
  buttonProps: ButtonProps;
}

const SalifyTextButton: FC<SalifyTextButtonProps> = ({ text, buttonProps }) => {
  return (
    <Button {...buttonProps} color={buttonProps?.color || "primary"} variant="text">
      {text}
    </Button>
  );
};

SalifyTextButton.displayName = "SalifyTextButton";

export default SalifyTextButton;
